import * as React from 'react';

import { Body } from 'bones/design-system/components/typography/Body';

export interface VoiceboxChatOutgoingProps {
  'data-testid'?: never;
  actions?: React.ReactNode;
  actionsRef?: React.Ref<HTMLDivElement>;
  content?: React.ReactNode;
  slot?: React.ReactNode;
  testId?: string;
  title?: string;
}

export const VoiceboxChatOutgoing: React.VFC<VoiceboxChatOutgoingProps> = ({
  actions,
  actionsRef,
  content,
  slot,
  testId,
  title,
}) => (
  <div className="vb-voicebox-chat-outgoing" data-testid={testId}>
    <div className="vb-voicebox-chat-indicator">
      <div className="vb-voicebox-chat-outgoing-body">
        {title ? (
          /* istanbul ignore next */
          <Body
            className="vb-voicebox-chat-outgoing-title"
            size="lg"
            weight="semibold"
          >
            {title}
          </Body>
        ) : null}
        {content ? (
          <Body className="vb-voicebox-chat-outgoing-content" size="md">
            {content}
          </Body>
        ) : /* istanbul ignore next */ null}
        {slot}
      </div>

      <div ref={actionsRef} className="vb-voicebox-chat-outgoing-actions">
        {actions}
      </div>
    </div>
  </div>
);
